import { getCompletReseauLcAsync } from '@/api/reseaux';
import { getProduitAssocie } from '@/api/devis';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import { gestionLiaisonsTarifProduitsAssocies } from '@/services/devis/gestionProduitsAssocies';
import { CATEGORIE_REGROUPEMENT_LC } from '@/configuration/produitConf';
import { REGROUPEMENT, ANNEE } from '@/configuration/devisConf';
import { getAffectionOfProductReseauLc, updateAffection } from '@/services/affectation/affectation';
import calculDateFin from '@/services/general/calculDateFin';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

async function generationLigneCommandeRegroupement(
  produitReseau, produitsAssocies, datePremierAffichage, reseau, listIdProduits,
  tauxTvaDefault,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande, tauxTvaDefault);
  nouvelleLigneCommande.title = produitsAssocies && produitsAssocies.libelle
    ? produitReseau.reference + ' - ' + produitsAssocies.libelle : produitReseau.reference;
  nouvelleLigneCommande.produitId = produitReseau.id;
  nouvelleLigneCommande.typeProduit = CATEGORIE_REGROUPEMENT_LC;
  nouvelleLigneCommande.produit = {};
  nouvelleLigneCommande.tauxTva = 0;
  nouvelleLigneCommande.dateDebut = datePremierAffichage || new Date();
  const dateFin = calculDateFin(
    nouvelleLigneCommande.dateDebut, produitsAssocies.quantite, produitsAssocies.uniteVente,
  );
  if (dateFin) {
    nouvelleLigneCommande.dateFin = dateFin;
  } else {
    nouvelleLigneCommande.dateFin = calculDateFin(nouvelleLigneCommande.dateDebut, 1, ANNEE);
  }
  nouvelleLigneCommande.libelle = produitReseau.libelle;
  nouvelleLigneCommande.masqueLigne = false;
  nouvelleLigneCommande.type = REGROUPEMENT;
  if (produitsAssocies && produitsAssocies.produitEnfant) {
    await gestionLiaisonsTarifProduitsAssocies(
      produitsAssocies, reseau, listIdProduits, CATEGORIE_REGROUPEMENT_LC);
    nouvelleLigneCommande.lignesCommande = await generationToutesLignesCommandes(
      produitsAssocies, reseau.extensionOpportunite.typeDeRemise, tauxTvaDefault,
    );
  } else nouvelleLigneCommande.lignesCommande = [];
  return nouvelleLigneCommande;
}

export default async function ajoutLignesCommandeProduitReseauLc(
  devisCommande, reseau, listIdProduits, ordre, tauxTvaDefault,
) {
  const produitReseau = (await getCompletReseauLcAsync(reseau.num)).data.result;
  let idProduitDefault = produitReseau.produitReseau.produitParDefautId;
  if (idProduitDefault === null) {
    idProduitDefault = listIdProduits.produit;
  }
  let liaisonTarif = [];
  if (idProduitDefault !== null && produitReseau.liaisonsTarif.length > 0) {
    liaisonTarif = returnLiaisonTarif(produitReseau, idProduitDefault, new Date());
  }
  if (!liaisonTarif) {
    const produitAssocie = (await getProduitAssocie(idProduitDefault))
      .data.result;
    liaisonTarif = genererLiaisonTarifFromProduitAssocie(
      produitAssocie,
    );
  }
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitReseau, liaisonTarif, devisCommande.datePremierAffichage, reseau, listIdProduits,
    tauxTvaDefault,
  );
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  const affectationList = await getAffectionOfProductReseauLc([nouvelleLignesCommande]);
  await updateAffection(
    nouvelleLignesCommande,
    devisCommande,
    affectationList[nouvelleLignesCommande.produitId],
  );
  return nouvelleLignesCommande;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/ajoutProduitReseauLc.js